module.exports = __webpack_public_path__ + "media/images/flags/SJ-544b1e9e256d89ffe1cad22f65579923.svg";